import { IconProps } from "types/icon.types";

function TicketIcon(props: IconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="currentColor" transform="translate(0,-952.36218)">
        <path
          d="m 4.7452,1016.5043 1.4142,1.4142 7.0711,7.071 1.4142,1.4143 1.4142,-1.4143 c 3.1409,-3.1409 8.1729,-3.1408 11.3137,0 3.141,3.141 3.1409,8.1728 0,11.3137 l -1.4142,1.4143 1.4142,1.4142 7.0711,7.071 1.4142,1.4143 1.4142,-1.4143 56.5685,-56.56847 1.4142,-1.41421 -1.4142,-1.41421 -7.071,-7.07107 -1.4142,-1.41422 -1.4143,1.41422 c -3.1409,3.1409 -8.1727,3.14098 -11.3137,0 -3.1408,-3.14082 -3.1409,-8.17281 0,-11.31371 l 1.4142,-1.41421 -1.4142,-1.41422 -7.071,-7.07107 -1.4143,-1.41421 -1.4142,1.41421 -56.5685,56.56847 -1.4142,1.4143 z m 5.6568,0 38.1838,-38.18378 25.4558,25.45588 -38.1837,38.1837 -4.5299,-4.5299 c 3.2742,-4.6751 3.0417,-11.1004 -1.127,-15.2691 -4.1678,-4.1679 -10.5941,-4.3995 -15.2691,-1.1269 l -4.5299,-4.5299 z m 41.0122,-41.0122 12.7279,-12.72793 4.53,4.52991 c -3.2726,4.67494 -3.041,11.10121 1.1269,15.26908 4.1686,4.16865 10.594,4.40119 15.2691,1.12696 l 4.5299,4.5299 -12.7279,12.72788 -25.4559,-25.4558 z"
          fillOpacity="1"
          stroke="none"
          visibility="visible"
          display="inline"
          overflow="visible"
        />
      </g>
    </svg>
  );
}

export default TicketIcon;
